import { z } from "zod";

export const getVideoParamsSchema = z.object({
	videoId: z.uuid(),
});

export type GetVideoParamsSchema = z.infer<typeof getVideoParamsSchema>;
